import { render } from "./AIScreenRecorder.vue?vue&type=template&id=c95468e6&scoped=true&ts=true"
import script from "./AIScreenRecorder.vue?vue&type=script&lang=ts"
export * from "./AIScreenRecorder.vue?vue&type=script&lang=ts"

import "./AIScreenRecorder.vue?vue&type=style&index=0&id=c95468e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95468e6"]])

export default __exports__